// Delegation survives the theme's native variant-picker replacement.
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-tcs-boots-return]');
  if (!button) return;
  const guide = button.closest('.tcs-boots-guide');
  const summary = guide?.querySelector('summary');
  if (!summary) return;
  guide.open = false;
  summary.focus({ preventScroll: true });
  summary.scrollIntoView({ block: 'center', behavior: 'auto' });
});

// Read the total from the native selected tier; do not duplicate discount arithmetic.
document.addEventListener('DOMContentLoaded', () => {
  const product = document.querySelector('product-info[data-boots-fit]');
  if (!product) return;
  const update = () => {
    const selected = product.querySelector('.tiered-option--active');
    const summary = product.querySelector('[data-boots-selection]');
    if (!selected || !summary) return;
    const quantity = Number(selected.dataset.quantity);
    const total = selected.querySelector('.tiered-option__final-price')?.textContent.trim();
    if (!total || !Number.isFinite(quantity)) return;
    const text = summary.dataset.template.replace('[sets]', String(quantity))
      .replace('[boots]', String(quantity * 4)).replace('[total]', total);
    if (summary.textContent !== text) summary.textContent = text;
  };
  product.addEventListener('click', () => requestAnimationFrame(update));
  product.addEventListener('change', () => requestAnimationFrame(update));
  new MutationObserver(update).observe(product, { childList: true, subtree: true });
  update();
});
